
import { SMCases, SMQuestionnaire } from "@/store";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class QuestionnaireActions extends Vue {
  get currentStep() {
    return SMQuestionnaire.currentStep;
  }

  beforeMount() {
    window.addEventListener("keydown", this.onEnterKeyDown);
  }

  beforeDestroy() {
    window.removeEventListener("keydown", this.onEnterKeyDown);
  }

  isNextLoading = false;
  isPreviousLoading = false;

  get canGoNext() {
    return SMQuestionnaire.canGoNext && !SMQuestionnaire.answerBlockEditing;
  }

  get hasHistory() {
    return SMQuestionnaire.hasHistory;
  }

  isVisible(id: number) {
    const condition = SMQuestionnaire.conditions.find((condition) => condition.target_id == id);

    if (!condition) return true;

    return condition.visible;
  }

  async onEnterKeyDown(event: KeyboardEvent) {
    if (this.isNextLoading || this.isPreviousLoading || !this.canGoNext) return;

    event.stopPropagation();

    if (!this.canGoNext) return;

    if (event.code !== "Enter") return;

    if (
      SMQuestionnaire.answerBlocks.some((el) => el.type === "textarea" && this.isVisible(el.ID))
    ) {
      return;
    }

    event.preventDefault();

    await this.$nextTick();

    await this.goNext();
  }

  async goNext() {
    if (this.isNextLoading || this.isPreviousLoading || !this.canGoNext) return;

    this.isNextLoading = true;

    await SMQuestionnaire.goNextQuestion();

    await this.$nextTick();

    await SMCases.updateService();

    this.isNextLoading = false;
  }

  async goBack() {
    if (this.isNextLoading || this.isPreviousLoading) return;

    this.isPreviousLoading = true;

    this.$root.$emit("questionnaire-go-previous-question");

    await this.$nextTick();

    await SMQuestionnaire.goPreviousQuestion();

    await this.$nextTick();

    this.isPreviousLoading = false;
  }
}
